import { createSelector } from 'reselect'
import { getCurrentUserSettingsSelector } from 'modules/settings/selectors'
import { ADDRESS_DOMAIN } from 'modules/address/constants'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { ADDRESS_MODEL_KEY } from 'models/daos/address/constants'
import { getObjectUtil } from 'packages/src'

function getUserAddressSelector () {
  return createSelector(
    getCurrentUserSettingsSelector(),
    state => state[ADDRESS_DOMAIN],
    (settings, addressDomain) => {
      const addressId = (
        getObjectUtil(settings, 'data.address.data.id') ||
        getObjectUtil(settings, 'changed.address.data.id')
      )

      return getObjectUtil(addressDomain.data, addressId)
    }
  )
}

function getCountryAddressSelector () {
  return createSelector(
    getUserAddressSelector(),
    (address) => {
      return getValueReduxUtil(address, ADDRESS_MODEL_KEY.COUNTRY)
    }
  )
}

export {
  getUserAddressSelector,
  getCountryAddressSelector
}
